import * as React from 'react'

function SvgDashboardLogo(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.635 0H1.823A1.825 1.825 0 000 1.823V6.51c0 1.006.818 1.823 1.823 1.823h7.812a1.825 1.825 0 001.823-1.823V1.823A1.825 1.825 0 009.635 0zM9.635 10.416H1.823A1.825 1.825 0 000 12.24v10.938C0 24.182.818 25 1.823 25h7.812a1.825 1.825 0 001.823-1.823V12.239a1.825 1.825 0 00-1.823-1.823zM23.177 16.666h-7.813a1.825 1.825 0 00-1.823 1.823v4.688c0 1.005.818 1.823 1.823 1.823h7.813A1.825 1.825 0 0025 23.177v-4.688a1.825 1.825 0 00-1.823-1.823zM23.177 0h-7.813a1.825 1.825 0 00-1.823 1.823V12.76c0 1.006.818 1.823 1.823 1.823h7.813A1.825 1.825 0 0025 12.76V1.823A1.825 1.825 0 0023.177 0z"
        fill="#fff"
        fillOpacity={0.8}
      />
    </svg>
  )
}

export default SvgDashboardLogo
